var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/schema.ts
var schema_exports = {};
__export(schema_exports, {
  auditLog: () => auditLog,
  employee: () => employee,
  timeEntry: () => timeEntry,
  timeSheet: () => timeSheet
});
import { sqliteTable, text, integer, index, uniqueIndex } from "drizzle-orm/sqlite-core";
var employee = sqliteTable(
  "employee",
  {
    /** CUID - eindeutig über alle Clients */
    id: text("id").primaryKey(),
    /** DATEV Personalnummer (z.B. "10042") - unique pro Mandant */
    personnelNumber: text("personnel_number").notNull(),
    firstName: text("first_name").notNull(),
    lastName: text("last_name").notNull(),
    /**
     * Zugeordneter Teamerfasser (Vorarbeiter).
     * Self-Reference: Ein Employee kann Vorarbeiter für andere sein.
     * SET NULL wenn Vorarbeiter gelöscht wird.
     */
    foremanId: text("foreman_id").references(() => employee.id, {
      onDelete: "set null"
    }),
    /** Aktiv/Inaktiv */
    active: integer("active", { mode: "boolean" }).notNull().default(true),
    // CRDT-Metadaten
    createdAt: text("created_at").notNull(),
    updatedAt: text("updated_at").notNull()
  },
  (table) => [
    // Personalnummer muss eindeutig sein (pro Mandant-DB)
    uniqueIndex("employee_personnel_number_idx").on(table.personnelNumber),
    // Schnelle Suche nach Team-Mitgliedern eines Vorarbeiters
    index("employee_foreman_id_idx").on(table.foremanId),
    // Filter nach aktiven Mitarbeitern
    index("employee_active_idx").on(table.active)
  ]
);
var timeSheet = sqliteTable(
  "time_sheet",
  {
    /** CUID - eindeutig über alle Clients */
    id: text("id").primaryKey(),
    /** Arbeitsdatum (YYYY-MM-DD) */
    date: text("date").notNull(),
    /**
     * Teamerfasser (Vorarbeiter) ID.
     * Referenziert employee.id - RESTRICT verhindert Löschen wenn Sheets existieren.
     */
    foremanId: text("foreman_id").notNull().references(() => employee.id, { onDelete: "restrict" }),
    /** Abteilungsleiter (Vorgesetzter) ID - keine FK da evtl. externe User-Tabelle */
    supervisorId: text("supervisor_id").notNull(),
    /** Kostenstelle ID - keine FK da cost_center Tabelle noch nicht existiert */
    costCenterId: text("cost_center_id").notNull(),
    /** Status: DRAFT | SUBMITTED | APPROVED | EXPORTED */
    status: text("status").notNull(),
    /**
     * Tagesabschluss durch Teamerfasser.
     * true = Teamerfasser kann nicht mehr bearbeiten.
     */
    taLocked: integer("ta_locked", { mode: "boolean" }).notNull().default(false),
    /** Freigegeben durch (User-ID) */
    approvedBy: text("approved_by"),
    /** Freigabezeitpunkt (ISO-8601) */
    approvedAt: text("approved_at"),
    /** Bemerkung des Abteilungsleiters */
    note: text("note"),
    /** GPS-Standort beim Tagesabschluss (JSON) */
    submissionLocation: text("submission_location", { mode: "json" }).$type(),
    // CRDT-Metadaten
    createdAt: text("created_at").notNull(),
    updatedAt: text("updated_at").notNull(),
    version: integer("version").notNull().default(1)
  },
  (table) => [
    // Hauptquery: Sheets eines Vorarbeiters an einem Tag
    uniqueIndex("time_sheet_foreman_date_idx").on(table.foremanId, table.date),
    // Filter nach Status (z.B. alle SUBMITTED für Admin-View)
    index("time_sheet_status_idx").on(table.status),
    // Datumsbasierte Abfragen (z.B. alle Sheets eines Tages)
    index("time_sheet_date_idx").on(table.date)
  ]
);
var timeEntry = sqliteTable(
  "time_entry",
  {
    /** CUID - eindeutig über alle Clients */
    id: text("id").primaryKey(),
    /**
     * Referenz zum TimeSheet.
     * CASCADE: Wenn Sheet gelöscht wird, werden alle Entries mit gelöscht.
     */
    timeSheetId: text("time_sheet_id").notNull().references(() => timeSheet.id, { onDelete: "cascade" }),
    /**
     * Interne Mitarbeiter-ID (CUID).
     * RESTRICT: Mitarbeiter kann nicht gelöscht werden solange Entries existieren.
     * Stattdessen: active=false setzen ("Soft Delete").
     */
    employeeId: text("employee_id").notNull().references(() => employee.id, { onDelete: "restrict" }),
    /** DATEV Personalnummer (denormalisiert für Offline/Archiv) */
    personnelNumber: text("personnel_number").notNull(),
    /** Mitarbeitername (denormalisiert für Offline-Anzeige) */
    employeeName: text("employee_name").notNull(),
    /**
     * Entry-Typ:
     * - WORK: Arbeitszeit
     * - TRAVEL: Fahrtzeit
     * - BREAK: Pause (explizit erfasst)
     * - SICK: Krank (vom Vorarbeiter gemeldet)
     * - VACATION: Urlaub (vom Vorarbeiter gemeldet)
     */
    type: text("type").notNull().$type(),
    /**
     * Status:
     * - RUNNING: Timer läuft noch (end_time = NULL)
     * - COMPLETED: Fertig erfasst
     */
    status: text("status").notNull().$type(),
    /** Arbeitsbeginn (ISO-8601) */
    startTime: text("start_time").notNull(),
    /** Arbeitsende (ISO-8601) - NULL wenn Timer noch läuft */
    endTime: text("end_time"),
    /** Pausendauer in Minuten */
    breakMinutes: integer("break_minutes").notNull().default(0),
    /** GPS-Snapshot bei Arbeitsbeginn (JSON) */
    startLocation: text("start_location", { mode: "json" }).$type(),
    /** GPS-Snapshot bei Arbeitsende (JSON) */
    endLocation: text("end_location", { mode: "json" }).$type(),
    /** Freitext-Bemerkung */
    note: text("note"),
    // CRDT-Metadaten
    createdAt: text("created_at").notNull(),
    updatedAt: text("updated_at").notNull(),
    version: integer("version").notNull().default(1)
  },
  (table) => [
    // Hauptquery: Alle Entries eines Sheets
    index("time_entry_time_sheet_id_idx").on(table.timeSheetId),
    // Suche nach Entries eines Mitarbeiters (z.B. für Reports)
    index("time_entry_employee_id_idx").on(table.employeeId),
    // Filter nach laufenden Timern
    index("time_entry_status_idx").on(table.status)
    // Multi-Session: Mehrere Entries pro MA pro Tag erlaubt (morgens, nachmittags, etc.)
    // Kein UNIQUE INDEX mehr auf (timeSheetId, employeeId)
  ]
);
var auditLog = sqliteTable(
  "audit_log",
  {
    /** CUID - eindeutig */
    id: text("id").primaryKey(),
    /** Zeitpunkt der Aktion */
    createdAt: text("created_at").notNull(),
    /**
     * Wer hat die Änderung vorgenommen (User-ID).
     * Keine FK da User-Tabelle evtl. extern (Auth-System).
     */
    userId: text("user_id").notNull(),
    /** Rolle des Users zum Zeitpunkt der Änderung */
    userRole: text("user_role").notNull(),
    /** Betroffene Entität (z.B. 'time_entry', 'time_sheet') */
    entity: text("entity").notNull(),
    /**
     * ID der betroffenen Entität.
     * Polymorphe Referenz - keine FK möglich da verschiedene Tabellen.
     */
    entityId: text("entity_id").notNull(),
    /**
     * Art der Aktion:
     * - UPDATE: Änderung bestehender Daten
     * - DELETE: Löschung
     * - MANUAL_CREATE: Manuelle Nacherfassung durch Admin/Supervisor
     */
    action: text("action").notNull().$type(),
    /**
     * Änderungen als JSON.
     * Format: { "field": { "old": value, "new": value } }
     */
    changes: text("changes", { mode: "json" }).$type().notNull(),
    /** Optionale Begründung für die Änderung */
    reason: text("reason")
  },
  (table) => [
    // Hauptquery: Alle Änderungen an einer bestimmten Entität
    index("audit_log_entity_idx").on(table.entity, table.entityId),
    // Änderungen eines Users (z.B. für Admin-Audit)
    index("audit_log_user_id_idx").on(table.userId),
    // Chronologische Abfragen
    index("audit_log_created_at_idx").on(table.createdAt),
    // Filter nach Aktionstyp
    index("audit_log_action_idx").on(table.action)
  ]
);

// src/client.ts
import { drizzle } from "drizzle-orm/libsql";
import { createClient } from "@libsql/client";
function createLocalDb(path = "data/local.db") {
  const client = createClient({
    url: `file:${path}`
  });
  return drizzle(client, { schema: schema_exports });
}
function createTursoDb(config) {
  const client = createClient({
    url: config.url,
    authToken: config.authToken
  });
  return drizzle(client, { schema: schema_exports });
}
function createDb(fallbackPath) {
  const tursoUrl = process.env["TURSO_DATABASE_URL"];
  const tursoToken = process.env["TURSO_AUTH_TOKEN"];
  if (tursoUrl && tursoToken) {
    console.info("[DB] Using Turso Cloud Database");
    return createTursoDb({ url: tursoUrl, authToken: tursoToken });
  }
  const localPath = process.env["DATABASE_PATH"] ?? fallbackPath ?? "data/local.db";
  console.info(`[DB] Using local SQLite: ${localPath}`);
  return createLocalDb(localPath);
}
var tenantDbCache = /* @__PURE__ */ new Map();
function getDbForTenant(tenantId, registry) {
  const cached = tenantDbCache.get(tenantId);
  if (cached) {
    return cached;
  }
  const config = registry[tenantId];
  if (!config) {
    throw new Error(`[DB] Unknown tenant: ${tenantId}`);
  }
  const client = createClient({
    url: config.url,
    authToken: config.authToken
  });
  const db = drizzle(client, { schema: schema_exports });
  tenantDbCache.set(tenantId, db);
  console.info(`[DB] Created DB connection for tenant: ${tenantId}`);
  return db;
}
function clearTenantDbCache() {
  tenantDbCache.clear();
  console.info("[DB] Tenant DB cache cleared");
}

// src/index.ts
import { eq, and, or, desc, asc, sql, inArray } from "drizzle-orm";

// src/seed-ids.ts
var SEED_IDS = {
  // Tenant & Foreman
  DEMO_TENANT: "clxdemo0tenant00000000000",
  DEMO_FOREMAN: "clxdemo0foreman0000000000",
  DEMO_SUPERVISOR: "clxdemo0supervi0000000000",
  DEMO_COST_CENTER: "clxdemo0costcen0000000000",
  // Mitarbeiter (5 Demo-Mitarbeiter)
  EMPLOYEE_MAX: "clxdemo0emp0max0000000000",
  EMPLOYEE_ERIKA: "clxdemo0emp0erika00000000",
  EMPLOYEE_HANS: "clxdemo0emp0hans000000000",
  EMPLOYEE_ANNA: "clxdemo0emp0anna000000000",
  EMPLOYEE_KLAUS: "clxdemo0emp0klaus00000000"
};
export {
  SEED_IDS,
  and,
  asc,
  auditLog,
  clearTenantDbCache,
  createDb,
  createLocalDb,
  createTursoDb,
  desc,
  employee,
  eq,
  getDbForTenant,
  inArray,
  or,
  sql,
  timeEntry,
  timeSheet
};
//# sourceMappingURL=index.js.map